<script context="module" lang="ts">
  import { userStorePageLoadFunction } from '$lib/stores/getUserStore';
  import type { ClientUserStore } from 'shared/src';
  export const load = userStorePageLoadFunction;
</script>

<script lang="ts">
  import TopicOrSkillBar from '$lib/app/skills/TopicOrSkillBar.svelte';
  import { autorun } from 'mobx';
  import { onDestroy } from 'svelte';
  import type { UserTopicStore } from 'shared/src/user/userKnowledge/user.topic.store';
  import { fade, fly } from 'svelte/transition';
  import H from '$lib/components/H.svelte';

  export let clientUserStore: ClientUserStore;

  let areas: {
    id: string;
    title: string;
    topics: UserTopicStore[];
    isVisible: boolean;
  }[];

  let selectedArea: string | null = null;
  const destroy = autorun(() => {
    areas = clientUserStore.knowledgeProgress.areas.map((area) => ({
      id: area.textId,
      title: area.title,
      isVisible: area.isVisible,
      topics: area.topics.filter((topic) => topic.isVisible),
    }));
  });
  onDestroy(destroy);
</script>

<div class="flex sm:m-4">
  <div
    class="hidden md:block area-select md:w-1/4 p-2 md:pr-4"
    in:fly={{ x: -400, duration: 1000 }}
  >
    <label class="plan-label" class:selected={selectedArea === null}
      >All areas<input type="radio" bind:group={selectedArea} name="skill-area" value={null} />
    </label>
    {#each areas as area}
      <label class="plan-label" class:selected={selectedArea === area.id}
        >{area.title}<input
          type="radio"
          bind:group={selectedArea}
          name="skill-area"
          value={area.id}
        />
      </label>
    {/each}
  </div>

  <div class="flex-grow card p-4" in:fade={{ duration: 250 }}>
    <div class="lg:flex lg:space-x-4 text-sm sm:text-base md:text-lg lg:text-base">
      {#each areas as area}
        {#if !selectedArea || selectedArea === area.id}
          <div class="flex-grow mb-4 {selectedArea === area.id ? 'flex-grow' : 'lg:w-1/3'}">
            <H level={2} class="text-center">{area.title}</H>
            {#if !area.isVisible}
              <p class="text-center">Area disabled by instructor.</p>
            {:else}
              <ul>
                {#each area.topics as topic, index}
                  <li class="my-1 h-10">
                    <a href="skills/start?topic={topic.textId}">
                      <TopicOrSkillBar {topic} {index} />
                    </a>
                  </li>
                {/each}
              </ul>
            {/if}
          </div>
        {/if}
      {/each}
    </div>
    <div class="text-4xl font-bold" />
    <!-- <TopicOrSkillBar topic={topics[0]} /> -->
  </div>
</div>

<style lang="postcss">
  .area-select {
    label {
      display: block;
      @apply p-2 hover:cursor-pointer transition-colors;
    }
    input {
      @apply opacity-0 w-0 h-0;
    }
    .selected {
      @apply bg-green text-white;
    }
  }
</style>
